
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import SignInDialog from '@/components/Auth/SignInDialog.vue';
import {
  authModule, challengeModule,
  followedModule,
  followedState,
  userModule
} from '@/utils/store-acessor';
import { UserModel } from '@/models/user.model';
import { ChallengeModel } from '@/models/challenge.model';
import ChallengeDialogNoProfile from '@/components/Challenges/ChallengeDialogNoProfile.vue';
import {nFormatter} from '@/utils/utils';

@Component({
  components: {
    ChallengeDialogNoProfile,
    SignInDialog
  }
})
export default class ChallengeFollowButton extends Vue {
  @Prop({ required: true }) challengeId!: number;
  @challengeModule.Getter('selectedChallenge')
  readonly challenge!: ChallengeModel | null;
  @Prop({ required: true, default: 0 }) followers!: number;
  @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
  @userModule.Getter('user') user!: UserModel;
  @followedModule.Getter('followedChallenges') followed!: ChallengeModel[];
  @followedModule.Getter('isFollowing') isFollowing!: (
    challengeId: number
  ) => boolean;
  @userModule.Getter('canAcceptChallenges') canAccept!: boolean;
  dialog: boolean = false;
  loading: boolean = false;
  signinDialog: boolean = false;
  confirmNoProfileDialog = false;
  // Snackbar
  snackbarVisibility: boolean = false;
  snackbarColor: string | null = null;
  snackbarText: string = '';

  @Watch('canAccept')
  async listenCanAccept(v: boolean) {
    if (v && !!this.user.slug) {
      await followedState.fetchfollowedChallenges(this.user.slug);
    }
  }

  async mounted() {
    if (this.user?.slug && this.canAccept) {
      await followedState.fetchfollowedChallenges(this.user.slug);
    }
  }

  async follow() {
    if (!this.isAuthenticated) {
      this.signinDialog = true;
      return;
    } else if (!this.canAccept) {
      this.confirmNoProfileDialog = true;
      return;
    }

    try {
      this.loading = true;
      if (this.challenge) {
        await followedState.follow(this.challenge);
        this.updateFollowers(true);
      }
      this.snackbarVisibility = true;
      this.snackbarColor = 'green';
      this.snackbarText = this.$t('challenge.follow.success').toString();
    } catch (error) {
      this.snackbarVisibility = true;
      this.snackbarColor = 'red';
      this.snackbarText = this.$t('challenge.follow.error').toString();
    } finally {
      this.loading = false;
    }
  }

  async unfollow() {
    try {
      this.loading = true;
      await followedState.unfollow(this.challengeId);
      this.updateFollowers(false);
      this.snackbarVisibility = true;
      this.snackbarColor = 'green';
      this.snackbarText = this.$t('challenge.unfollow.success').toString();
    } catch (error) {
      this.snackbarVisibility = true;
      this.snackbarColor = 'red';
      this.snackbarText = this.$t('challenge.unfollow.error').toString();
    } finally {
      this.loading = false;
    }
  }

  formatCounter(value: number) {
    return nFormatter(value)
  }

  @Emit('update:followers')
  updateFollowers(increment: boolean): number {
    const result: number = increment ? this.followers + 1 : this.followers - 1;
    return result < 0 ? 0 : result;
  }

  openProfilePage() {
    this.$router.push('/profile/config');
  }
}
